// import store from "@/store";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { _langFreeReel } from '@/utils//langforFreereel'

// 核心页面路由
const getCoreRoutes = (): RouteRecordRaw[] => [
  {
    path: "/",
    name: "reelfree",
    component: () =>
      import(/* webpackChunkName: "reel-free-core-website" */ "../views-reel-free/website/index.vue"),
    meta: {
      title: 'Reelfree',
    },
  },
];

// 反馈相关路由
const getFeedbackRoutes = (): RouteRecordRaw[] => [
  {
    path: "/issue",
    name: "ISSUE",
    component: () =>
      import(/* webpackChunkName: "reel-free-feedback-issue" */ "../views-reel-free/issue/index.vue"),
    meta: {
      title: _langFreeReel('FEEDBACK'),
    },
  },
  {
    path: "/feedBacks",
    name: "Message",
    component: () =>
      import(/* webpackChunkName: "reel-free-feedback-messages" */ "../views-reel-free/feedBacks/index.vue"),
    meta: {
      title: _langFreeReel('Message'),
    },
  },
  {
    path: "/evaluate",
    name: "EVALUATE",
    component: () =>
      import(/* webpackChunkName: "reel-free-feedback-evaluate" */ "../views-reel-free/evaluate/index.vue"),
    meta: {
      title: _langFreeReel('Rating'),
    },
  },
];

// 问卷调查相关路由
const getQuestionnaireRoutes = (): RouteRecordRaw[] => [
  {
    path: "/questionnaire",
    name: "WELCOME",
    component: () =>
      import(/* webpackChunkName: "reel-free-questionnaire-main" */ "../views-reel-free/questionnaire/index.vue"),
    meta: {
      title: _langFreeReel('Survey'),
    },
  },
  {
    path: "/questionnaire/question",
    name: "FILL Survey",
    component: () =>
      import(/* webpackChunkName: "reel-free-questionnaire-question" */ "../views-reel-free/questionnaire/question.vue"),
    meta: {
      title: _langFreeReel('Survey'),
    },
  },
  {
    path: "/questionnaire/thanks",
    name: "THANKS",
    component: () =>
      import(/* webpackChunkName: "reel-free-questionnaire-thanks" */ "../views-reel-free/questionnaire/thanks.vue"),
    meta: {
      title: _langFreeReel('Survey'),
    },
  },
];

// 法律和分享相关路由
const getLegalAndSharingRoutes = (): RouteRecordRaw[] => [
  {
    path: "/secret",
    name: "SECRET",
    component: () =>
      import(/* webpackChunkName: "reel-free-legal-privacy" */ "../views-reel-free/secret/index.vue"),
    meta: {
      title: _langFreeReel('privacyPolicy'),
    },
  },
  {
    path: "/readme",
    name: "README",
    component: () =>
      import(/* webpackChunkName: "reel-free-legal-terms" */ "../views-reel-free/readme/index.vue"),
    meta: {
      title: _langFreeReel('termsServices'),
    },
  },
  {
    path: "/share",
    name: "SHARE",
    component: () =>
      import(/* webpackChunkName: "reel-free-social-share" */ "../views-reel-free/share/index.vue"),
    meta: {
      title: 'SHARE',
    },
  },
];

// 组合所有路由
const routes: Array<RouteRecordRaw> = [
  ...getCoreRoutes(),
  ...getFeedbackRoutes(),
  ...getQuestionnaireRoutes(),
  ...getLegalAndSharingRoutes(),
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title as string
  } else {
    document.title = ''
  }
  next()
})

export default router;
